export default __webpack_public_path__ + "static/media/laravel.f6cc86d5.png";